import { createReducer } from '@reduxjs/toolkit';
import { DEBUG_LOG } from '../actions/debug';

export type DebugLogState = {
  debugLogs: string[];
};

const initState: DebugLogState = {
  debugLogs: [],
};
const limit = 100;

const debugLogsReducer = createReducer(initState, (builder) =>
  builder.addCase(DEBUG_LOG, (state, action) => {
    const log = action.payload.join(' ');
    const logs = [log].concat(state.debugLogs);
    if (logs.length > limit) logs.pop();
    return { ...state, debugLogs: logs };
  })
);

export default debugLogsReducer;
